// export const url = "http://localhost:3064/api";
export const url = "https://dev-api.houseofalliances.com/api";
// export const url = "https://erp-api.zsmaterials.in/api";
export const IMAGE_URL =
  "http://dev-api.houseofalliances.com/api/image/upload-image";
